// @flow
import type { PaginationHeaders } from '@globalTypes';
import {
  BLOG_ARTICLES_ERROR,
  BLOG_ARTICLES_REQUEST,
  BLOG_ARTICLES_REQUESTED,
  BLOG_ARTICLES_RESET,
  BLOG_ARTICLE_ERROR,
  BLOG_ARTICLE_REQUEST,
  BLOG_ARTICLE_REQUESTED,
  BLOG_CATEGORIES_REQUEST,
  BLOG_CATEGORIES_REQUESTED,
  BLOG_TESTIMONIALS_REQUEST,
  BLOG_TESTIMONIALS_REQUESTED
} from './constants';

import type {
  Categories, Action, CategorySlugs, Articles, Article
} from '../types';

export const requestBlogCategories = (): Action => ({
  type: BLOG_CATEGORIES_REQUEST
});

export const requestBlogArticles = ({
  categoryTypes,
  pageNumber,
  customPerPage,
  treatment_id,
  department
}: {
  categoryTypes?: CategorySlugs,
  pageNumber?: number,
  customPerPage?: number,
  treatment_id?: string,
  department?: string,
}): Action => ({
  type: BLOG_ARTICLES_REQUEST,
  pageNumber,
  categoryTypes,
  customPerPage,
  treatment_id,
  department
});

export const requestBlogArticle = (slug: string): Action => ({
  type: BLOG_ARTICLE_REQUEST,
  slug
});

export const updateBlogArticle = (dataArticle: Article, included: any): Action => ({
  type: BLOG_ARTICLE_REQUESTED,
  dataArticle,
  included
});

export const errorBlogArticle = (error: Error): Action => ({
  type: BLOG_ARTICLE_ERROR,
  error
});

export const updateBlogArticles = (
  dataArticles: Articles,
  included: any,
  headers: PaginationHeaders
): Action => ({
  type: BLOG_ARTICLES_REQUESTED,
  dataArticles,
  included,
  headers
});

export const updateBlogCategories = (dataCategories: Categories): Action => ({
  type: BLOG_CATEGORIES_REQUESTED,
  dataCategories
});

export const errorBlogArticles = (error: Error): Action => ({
  type: BLOG_ARTICLES_ERROR,
  error
});

export const errorBlogCategories = (error: Error): Action => ({
  type: BLOG_CATEGORIES_REQUEST,
  error
});

export const requestBlogTestimonial = (customPerPage: number, treatment_id?: string): Action => ({
  type: BLOG_TESTIMONIALS_REQUEST,
  customPerPage,
  treatment_id
});

export const updateBlogTestimonial = (dataTestimonials: Articles, included: any): Action => ({
  type: BLOG_TESTIMONIALS_REQUESTED,
  dataTestimonials,
  included
});

export const resetBlogArticles = (): Action => ({ type: BLOG_ARTICLES_RESET });
